import { Language, Lightning } from "@lightningjs/sdk";
import { CategoryList } from "../../components/data-display/CategoryList/CategoryList";
import { MENU_WIDTH } from "../../lib/utils";
import { CategoryModel } from "../../lib/models";
import theme from "../../lib/theme";

interface MediaTypeGroupedTemplateSpec extends Lightning.Component.TemplateSpec {
    List: typeof CategoryList;
}

interface MediaTypeGroupedTypeConfig extends Lightning.Component.TypeConfig {
    IsPage: true;
}

/**
 * Movies / Series page grouped by category: renders a CategoryList where every
 * row is a CMS category showing only its `contentTypes` content (movie/series).
 * The route fetches the categories (already filtered + non-empty) and sets
 * `pageName` (for the menu highlight), `contentTypes`, then `data`.
 */
export class MediaTypeGrouped
    extends Lightning.Component<MediaTypeGroupedTemplateSpec, MediaTypeGroupedTypeConfig>
    implements Lightning.Component.ImplementTemplateSpec<MediaTypeGroupedTemplateSpec>
{
    _contentTypes?: string;
    _pageName?: string;
    _lastLocale = Language.get();

    static override _template(): Lightning.Component.Template<MediaTypeGroupedTemplateSpec> {
        return {
            List: {
                type: CategoryList,
                x: MENU_WIDTH,
                y: theme.banner.padding.y
            }
        };
    }

    readonly List = this.getByRef("List")!;

    override _getFocused(): Lightning.Component | null | undefined {
        return this.List;
    }

    override _firstActive() {
        if (this._pageName) this.application.emit("setActivePage", this._pageName);
    }

    override _active() {
        if (this._pageName) this.application.emit("setActivePage", this._pageName);
    }

    override _inactive() {
        this._lastLocale = Language.get();
        this.stage.gc();
    }

    set pageName(value: string) {
        this._pageName = value;
    }

    set contentTypes(value: string) {
        this._contentTypes = value;
        this.List.contentTypes = value;
    }

    set data(value: CategoryModel[]) {
        this.application.emit("clearBackground");
        this.List.contentTypes = this._contentTypes;
        this.List.reload(value);
        this._lastLocale = Language.get();
    }
}
